import type { Theme } from '@mui/material/styles';

/** Palette + Blocks panel item background (PROFESSIONAL dark uses rgb(25, 25, 25)). */
export const emailBuilderBlockBackground = (theme: Theme): string =>
    theme.palette.dashboard?.emailBuilderBlockBackgroundColor
    ?? (theme.palette.mode === 'dark' ? 'rgb(20, 25, 55)' : '#dedad2');

/** Drop-zone placeholder background in the layout canvas. */
export const emailBuilderDropZoneBackground = (theme: Theme): string =>
    theme.palette.dashboard?.emailBuilderBlockBackgroundColor
    ?? (theme.palette.mode === 'dark' ? 'rgb(20, 25, 55)' : '#f5f5f5');
